import { ISession } from '.';
import {
    TRAINEE_AND_EARLY_CAREER_DAY_SESSION_ID,
    TRAINEE_AND_EARLY_CAREER_DINNER_SESSION_ID,
} from '@/constants/constants';

export const sortSessionsWithTAndECDinnerAfterDay = (sessions: ISession[]) => {
    const sortedSessions = [...sessions].sort((a, b) => {
        if (a.session.startTime === b.session.startTime) {
            if (a.session.endTime === b.session.endTime) {
                return a.session.name! < b.session.name! ? -1 : 1;
            }

            return a.session.endTime! < b.session.endTime! ? -1 : 1;
        }

        return a.session.startTime! < b.session.startTime! ? -1 : 1;
    });

    const dayIndex = sortedSessions.findIndex(
        item => item.session.id === TRAINEE_AND_EARLY_CAREER_DAY_SESSION_ID
    );
    const dinnerIndex = sortedSessions.findIndex(
        item => item.session.id === TRAINEE_AND_EARLY_CAREER_DINNER_SESSION_ID
    );

    if (dayIndex >= 0 && dinnerIndex >= 0) {
        const [dinner] = sortedSessions.splice(dinnerIndex, 1);
        const updatedDayIndex = sortedSessions.findIndex(
            item => item.session.id === TRAINEE_AND_EARLY_CAREER_DAY_SESSION_ID
        );
        sortedSessions.splice(updatedDayIndex + 1, 0, dinner);
    }

    return sortedSessions;
};
